import { doorman, elevator, petFriendly } from "../../../assets";

export default [
  {
    name: "pets",
    value: "Pets allowed",
    imgSrc: petFriendly.toString()
  },
  {
    name: "elevator",
    value: "Elevator",
    imgSrc: elevator.toString()
  },
  {
    name: "doorman",
    value: "Doorman",
    imgSrc: doorman.toString()
  }
];
